// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VWEb","selected":"styles_selected__20MiY"};